// React
import React from 'react'

// Components
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { LoginForm } from '@/components/blocks/login-form'

// External
import { VisuallyHidden } from '@radix-ui/themes'

type LoginButtonProps = {
  buttonText: string
  buttonIcon: React.ReactNode
  className?: string
  redirectUrl?: string
}

const LoginButton: React.FC<LoginButtonProps> = ({
  buttonText,
  buttonIcon,
  className,
  redirectUrl,
}) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant='default' className={className}>
          {buttonIcon}
          <span>{buttonText}</span>
        </Button>
      </DialogTrigger>
      <DialogContent className='sm:max-w-[425px]'>
        <VisuallyHidden>
          <DialogTitle>Login</DialogTitle>
        </VisuallyHidden>
        <LoginForm isDialog={true} redirectUrl={redirectUrl} />
      </DialogContent>
    </Dialog>
  )
}

export { LoginButton }
